/**
 * Timestamp helpers for behavioural segment evaluators (pure).
 */

/**
 * @param {unknown} v
 * @returns {number|null}
 */
export function toMsFromFirestoreValue(v) {
  if (v == null) return null;
  try {
    if (typeof v === 'number' && !Number.isNaN(v)) return v;
    if (v && typeof v.toMillis === 'function') return v.toMillis();
    if (v && v.seconds != null) return Number(v.seconds) * 1000;
    if (v instanceof Date) return v.getTime();
    const p = Date.parse(String(v));
    return Number.isNaN(p) ? null : p;
  } catch {
    return null;
  }
}

/**
 * @param {number|null} ms
 * @param {number} nowMs
 * @returns {number|null}
 */
export function daysSinceMs(ms, nowMs) {
  if (ms == null || !Number.isFinite(ms)) return null;
  return Math.floor((nowMs - ms) / (24 * 60 * 60 * 1000));
}

/**
 * ISO week id (UTC) for cadence predicates.
 * @param {number} ms
 * @returns {string}
 */
export function isoWeekKey(ms) {
  const date = new Date(ms);
  const tmp = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
  const dayNum = tmp.getUTCDay() || 7;
  tmp.setUTCDate(tmp.getUTCDate() + 4 - dayNum);
  const yearStart = new Date(Date.UTC(tmp.getUTCFullYear(), 0, 1));
  const weekNo = Math.ceil(((tmp - yearStart) / 86400000 + 1) / 7);
  return `${tmp.getUTCFullYear()}-W${String(weekNo).padStart(2, '0')}`;
}

/**
 * @param {number} days
 * @param {number} nowMs
 * @returns {number}
 */
export function windowStartMsForDays(days, nowMs) {
  const d = Math.max(1, Math.floor(Number(days) || 1));
  return nowMs - d * 24 * 60 * 60 * 1000;
}
